/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Reader_SkipsInputs */

const en_funnel_sq_reader_skips = /** @type {(inputs: Funnel_Sq_Reader_SkipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`skips citations`)
};

const es_funnel_sq_reader_skips = /** @type {(inputs: Funnel_Sq_Reader_SkipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`omite las citas`)
};

/**
* | output |
* | --- |
* | "skips citations" |
*
* @param {Funnel_Sq_Reader_SkipsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_reader_skips = /** @type {((inputs?: Funnel_Sq_Reader_SkipsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Reader_SkipsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_reader_skips(inputs)
	return en_funnel_sq_reader_skips(inputs)
});